import React from 'react';
import {Button} from "react-bootstrap";
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import * as actions from '../../../_redux/paymentsActions';
import can from "../../../../_common/components/Permissions/can";

export function UpdateStatusColumnFormatter(cellContent, intl, dispatch) {

  return (
    <Button
      className="btn btn-icon btn-light btn-sm mx-3 custom-action-button"
      onClick={() => {
        dispatch(actions.updateManualStatusAction(
          cellContent?._id,
          cellContent?.agentID,
          cellContent?.paymentRequestDate
        ));
      }}
      title={intl.formatMessage({id: "automatedPayments-tooltip-updateStatus", defaultMessage: "Update status"})}
      disabled={!can('full', 'bituahLeumiPayment')}
    >
      <img
        src={toAbsoluteUrl('/media/svg/Check_brandColor.svg')}
        alt="update"
      />
    </Button>
  )
}
